import { Hint } from "@/components/email/EmailBadges";
import { cn } from "@/lib/utils";

/** "2 / 4" with one dot per step, filled up to the last sent. */
export function StepProgress({ current, total }: { current: number | null; total: number }) {
  if (!total) return <span className="text-xs text-slate-400">—</span>;
  const done = current ?? 0;
  return (
    <Hint content={done ? `Last sent: step ${done} of ${total}` : `Nothing sent yet · ${total} steps`}>
      <span className="inline-flex items-center gap-1.5">
        <span className="flex gap-0.5">
          {Array.from({ length: total }, (_, i) => (
            <span key={i} className={cn("h-1.5 w-3 rounded-full", i < done ? "bg-indigo-500" : "bg-slate-200")} />
          ))}
        </span>
        <span className="text-xs tabular-nums text-slate-500">
          {done}/{total}
        </span>
      </span>
    </Hint>
  );
}
